import type { Event } from "../types/event";

export const mockEvents: Event[] = [
    {
        id: 1,
        slug: "journee-5-stade-leo-lagrange",
        title: "Journée 5 au Stade Léo Lagrange",
        summary:
            "Trois affiches, une journée de football communautaire et un barbecue géant de 9h à 18h.",
        description:
            "La Journée 5 de la Ligue des 2 Zéros réunira plusieurs équipes au Stade Léo Lagrange à Guénange. Entre matchs, ambiance, restauration et moments de partage, cette journée s’annonce comme l’un des temps forts de la saison.",
        image: "/images/events/event-j5-guenange.jpg",
        dateLabel: "Dimanche 22 mars",
        timeLabel: "09h00 - 18h00",
        location: "Stade Léo Lagrange, 66 Rue des Ronces, Guénange, France",
        featured: true,
    },
];